const selectors = {
  form: '.js-form:not(.is-initialized)',
  results: '.js-form-results',
  submit: '.js-form-submit',
};

const classes = {
  loading: 'is-loading',
  loaded: 'is-loaded',
};

let abortController;

const onFormUpdate = form => {
  if (!form.checkValidity()) return;

  const resultsContainer = document.querySelector(
    selectors.results + '#results-' + form.id,
  );
  resultsContainer.classList.add(classes.loading);
  form.classList.add(classes.loading);
  resultsContainer.style.height = resultsContainer.offsetHeight + 'px';

  if (abortController) {
    // In case a fetch is already running, abort it.
    abortController.abort();
  }

  loadResults(form);
};

const loadResults = form => {
  abortController = new AbortController();
  const { signal } = abortController;

  const data = new FormData(form);
  const action = form.getAttribute('action') || window.location.href;
  const url = `${action}?${new URLSearchParams(data).toString()}`;

  fetch(url, { signal })
    .then(response => response.text())
    .then(res => {
      window.history.pushState({ path: url }, '', url);

      const parser = new DOMParser();
      const doc = parser.parseFromString(res, 'text/html');
      const results = doc.querySelector(
        selectors.results + '#results-' + form.id,
      );
      const resultsContainer = document.querySelector(
        selectors.results + '#results-' + form.id,
      );

      const newForm = doc.querySelector(selectors.form + '#' + form.id);
      const newSubmit = newForm.querySelector(selectors.submit);
      const submit = form.querySelector(selectors.submit);
      if (newSubmit && submit) {
        submit.innerHTML = newSubmit.innerHTML;
      }

      const expandableToggles = [...newForm.querySelectorAll('.js-expandable-toggle')];
      expandableToggles.forEach(toggle => {
        const target = form.querySelector(`#${toggle.id}`);
        if (target) {
          target.innerHTML = toggle.innerHTML;
        }
      });

      const newFormEls = [...newForm.elements];
      newFormEls.forEach(el => {
        const field = el;
        if (!field.name) return;

        const targetField = form.elements[field.name];
        if (!targetField) return;

        switch (field.type) {
          case 'checkbox':
          case 'radio':
            targetField.checked = field.checked;
            break;
          default:
            targetField.value = field.value;
        }
      });

      resultsContainer.classList.add(classes.loaded);
      form.classList.add(classes.loaded);

      setTimeout(() => {
        resultsContainer.innerHTML = results.innerHTML;
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            // Appending takes more than 1 frame on FF
            document.dispatchEvent(new CustomEvent('domUpdated'));

            resultsContainer.classList.remove(classes.loading);
            form.classList.remove(classes.loading);
            resultsContainer.classList.remove(classes.loaded);
            form.classList.remove(classes.loaded);

            requestAnimationFrame(() => {
              resultsContainer.style.height = '';
              resultsContainer.scrollIntoView();
            });
          });
        });
      }, 400);
    })
    .catch(err => {
      if (err.name === 'AbortError') return;
      console.warn(err);
    });
};

const init = () => {
  const forms = document.querySelectorAll(selectors.form);

  forms.forEach(form => {
    const modal = form.closest('.js-modal');
    const submit = form.querySelector('button[type="submit"]:not(.u-no-js');

    form.addEventListener('change', () => {
      if (submit) return;
      onFormUpdate(form);
    });

    form.addEventListener('submit', e => {
      e.preventDefault();
      if (modal && modal.modal) modal.modal.closeModal();

      onFormUpdate(form);
    });

    form.addEventListener('reset', e => {
      e.preventDefault();

      const inputs = form.querySelectorAll(
        'input[type="radio"], input[type="checkbox"]',
      );
      inputs.forEach(input => {
        input.checked = false;
      });

      const selects = form.querySelectorAll('select');
      selects.forEach(select => {
        select.selectedIndex = 0;
      });

      onFormUpdate(form);
    });
  });
};

const module = () => {
  init();
  document.addEventListener('domUpdated', init);
};

export default module;
